import React from "react";
import { usePermissions } from "../../hooks/usePermissions";

/**
 * Renders children only when the user has the given module privilege.
 * Use action="export" to show export controls for any module access level.
 */
const PermissionGate = ({ module, action = "view", children, fallback = null }) => {
  const { can, canExport, profileLoaded } = usePermissions();

  if (!profileLoaded) return null;
  if (action === "export") {
    if (!canExport(module)) return fallback;
    return <>{children}</>;
  }
  if (!can(module, action)) return fallback;

  return <>{children}</>;
};

export default PermissionGate;
